import BuyboxExp4 from './index';
import type { SnowplowClickoutContext, SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { BuyBoxFilterOptions } from './utils';
import { OfferPresentationType } from '@/interfaces/titles';

const property = 'buybox' as const;

export const buyboxExp4TrackImpression = () => BuyboxExp4.trackEvent({ action: 'impression', property });

export const buyboxExp4TrackClickout = (contexts: SnowplowClickoutContext[]) =>
	BuyboxExp4.trackEvent({
		action: 'click',
		label: 'clickout',
		property,
		contexts,
	});

export const buyboxExp4TrackMoreInfoModalClick = (contexts: SnowplowClickoutContext[]) =>
	BuyboxExp4.trackEvent({
		action: 'click',
		label: 'more_info_clicked',
		property,
		contexts,
	});

export const buyboxExp4TrackFreeTrialClickout = (contexts: SnowplowClickoutContext[]) =>
	BuyboxExp4.trackEvent({
		action: 'click',
		label: 'free_trial_clickout',
		property,
		contexts,
	});

export const buyboxExp4TrackNotifyMeClick = (contexts: SnowplowContext[]) =>
	BuyboxExp4.trackEvent({
		action: 'click',
		label: 'notify_me_clicked',
		property,
		contexts,
	});

export const buyboxExp4TrackBuyBoxFilterClick = (
	contexts: SnowplowContext[],
	label: BuyBoxFilterOptions | OfferPresentationType | null
) =>
	BuyboxExp4.trackEvent({
		action: 'click',
		label: `filter_${label ? label?.toLowerCase() : 'best'}`,
		property,
		contexts,
	});
